<template>
	<component
		:is="type"
		class="leading-normal"
		:class="{
			'text-base': size == 'big',
			'text-sm': size == 'normal',
			'text-xs': size == 'small',
		}"
	>
		<slot></slot>
	</component>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
	name: "BaseText",
	props: {
		type: {
			type: String,
			default: "p",
		},
		size: {
			type: String,
			default: "normal",
			validator: (value: string) => ["big", "normal", "small"].includes(value),
		},
	},
});
</script>
